import React from 'react';
import './Card.css';

/**
 * Componente Card reutilizable
 * @param {ReactNode} children - Contenido de la tarjeta
 * @param {string} className - Clases CSS adicionales
 * @param {boolean} hoverable - Si la tarjeta tiene efecto hover
 */
const Card = ({ children, className = '', hoverable = false }) => {
    const classNames = [
        'card',
        hoverable ? 'card--hoverable' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={classNames}>
            {children}
        </div>
    );
};

export default Card;
